import { parseQueryString } from '@packages/shared';
import type { HashDataObject } from '../../types/HashDataObject';
import { getSanitizedSku } from '../getSanitizedSku/getSanitizedSku';

export const getUrlParameters = (
  hashQuery?: string | null,
  searchQuery?: string | null,
  forcePreselect: boolean = false,
  usePrintPromo: boolean = true,
): HashDataObject => {
  const returnObject: HashDataObject = {
    category: undefined,
    engraving: undefined,
    features: undefined,
    isPreselectedDimension: forcePreselect,
    layerId: undefined,
    length: undefined,
    position: undefined,
    printProductId: undefined,
    query: undefined,
    searchNo: undefined,
    searchPage: undefined,
    variationId: undefined,
    width: undefined,
  };

  if (hashQuery) {
    const hashObject = parseQueryString(hashQuery);

    returnObject.isPreselectedDimension = forcePreselect || hashObject['nav-pd'] === 'true';
    returnObject.category = hashObject['nav-c'];

    if (hashObject.sku) {
      /** sanitize variationId for use with "old" three-part sku */
      returnObject.variationId = getSanitizedSku(
        hashObject.sku,
        returnObject.isPreselectedDimension,
      );
    }

    returnObject.query = hashObject['nav-q'];
    returnObject.searchPage = hashObject['nav-p'];
    returnObject.position = hashObject['nav-i'];
    returnObject.features = hashObject.features;
    returnObject.length = hashObject.length;
    returnObject.width = hashObject.width;
    returnObject.engraving = hashObject.engraving;
    returnObject.searchNo = hashObject['search-no'] === 'true';
  }

  /** handle searchQuery and overwrite hash params if needed */
  if (searchQuery) {
    const searchObject = parseQueryString(searchQuery);

    if (usePrintPromo) {
      returnObject.printProductId = searchObject.pp;
    }
    if (searchObject['nav-pd'] === 'true') {
      returnObject.isPreselectedDimension = true;
    }
    if (searchObject.sku) {
      /** sanitize variationId for use with "old" three-part sku */
      returnObject.variationId = getSanitizedSku(
        searchObject.sku,
        returnObject.isPreselectedDimension,
      );
    }
    if (searchObject['nav-c']) {
      /** remove '@...' from category */
      returnObject.category = searchObject['nav-c'].split('@').at(0);
    }
    if (searchObject.length) {
      returnObject.length = searchObject.length;
    }
    if (searchObject.width) {
      returnObject.width = searchObject.width;
    }
    if (searchObject.engraving) {
      returnObject.engraving = searchObject.engraving;
    }
    returnObject.layerId = searchObject.openLayer;
  }

  // decode engraving
  if (returnObject.engraving) {
    returnObject.engraving = decodeURIComponent(returnObject.engraving);
  }

  return returnObject;
};
